<template>
  <div class="menu">
    <router-link
      to="/home"
      tag="div"
      class="menu-item-wrapper"
    >
      <div class="menu-item" :class="[active == 'home' ? 'active': '']">
        <p class="item-icon"><i class="fa fa-home"></i></p>
        <p class="item-text">home</p>
      </div>
    </router-link>
    <router-link
      to="/notifications"
      tag="div"
      class="menu-item-wrapper"
    >
      <div class="menu-item" :class="[active == 'notification' ? 'active': '']">
        <p v-if="noticeNum > 0" class="unread">{{noticeNum}}</p>
        <p class="item-icon"><i class="fa fa-bell"></i></p>
        <p class="item-text">notification</p>
      </div>
    </router-link>
    <router-link
      to="/timeline"
      tag="div"
      class="menu-item-wrapper"
    >
      <div class="menu-item" :class="[active == 'timeline' ? 'active': '']">
        <!-- <p v-if="noticeNum > 0" class="unread">{{noticeNum}}</p> -->
        <p class="item-icon"><i class="fa fa-feed"></i></p>
        <p class="item-text">timeline</p>
      </div>
    </router-link>
    <router-link
      to="/my-list"
      tag="div"
      class="menu-item-wrapper"
    >
      <div class="menu-item" :class="[active == 'mylist' ? 'active': '']">
        <p class="item-icon"><i class="fa fa-list"></i></p>
        <p class="item-text">my list</p>
      </div>
    </router-link>
    <router-link
      :to="{ name: 'account.index', params: {name: $store.state.account.name }}"
      tag="div"
      class="menu-item-wrapper"
    >
      <div class="menu-item" :class="[active == 'profile' ? 'active': '']">
        <p class="item-icon"><i class="fa fa-user"></i></p>
        <p class="item-text">profile</p>
      </div>
    </router-link>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  neme: 'Menu',
  props: ['active'],

  data() {
    return {
      noticeNum: 0,
    };
  },

  mounted() {
    axios.get(`private/notifications/count/${this.$store.state.account.id}`).then(data => {
      this.noticeNum = data.data.notifications
    }).catch(err => {
    })
  },
}
</script>

<style scoped>
.menu {
  position: fixed;
  bottom: 0;
  height: 80px;
  width: 100vw;
  z-index: 5;
  display: flex;
  background: #F4F4F4;
}

.menu-item {
  color: #5C5C5C;
  padding: 5px;
  margin: 0;
  text-align: center;
  position: relative;
}

.item-text {
  line-height: 0;
  margin-top: 12px;
}

.item-icon {
  margin: 0;
  margin-top: 5px;
  font-size: 25px;
  line-height: 0
}

.active {
  color: #F39939;
}

.menu-item-wrapper {
  width: 25%;
}

.unread {
  position: absolute;
  z-index: 1;
  border-radius: 50%;
  display: inline-block;
  background: #f39938;
  color: #fff;
  width: 30px;
  height: 30px;
  padding: 3px;
  top: -20%;
}

@media (min-width: 880px) {
  .menu {
    height: 65px;
  }
}
</style>
